import React from "react"
import { useLocation } from "react-router-dom";
import HeaderFullSize from "./HeaderFullSize";
import HeaderMini from "./HeaderMini";
import useViewportMinimized from "../../../Code/useViewportMinimized";

export default function Header({ isDonateYourCard: isDonateYourCardProp, selectedCharity }) {
  const showMinimized = useViewportMinimized();

  const location = useLocation();
  const isDonateYourCard = isDonateYourCardProp || location.state?.isDonateYourCard;

  return showMinimized
    ? <HeaderMini isDonateYourCard={isDonateYourCard} selectedCharity={selectedCharity} />
    : <HeaderFullSize isDonateYourCard={isDonateYourCard} selectedCharity={selectedCharity} />;
}